import { render, staticRenderFns } from "./ThreatFeedIcons.vue?vue&type=template&id=e481e890&scoped=true&"
import script from "./ThreatFeedIcons.vue?vue&type=script&lang=js&"
export * from "./ThreatFeedIcons.vue?vue&type=script&lang=js&"
import style0 from "./ThreatFeedIcons.vue?vue&type=style&index=0&id=e481e890&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e481e890",
  null
  
)

export default component.exports